// AppBarComponent renders a 56px (xs) / 72px (md+) logo plus 4-6px vertical
// padding plus the inner Toolbar's intrinsic min-height. The MUI <Toolbar/>
// placeholder only reserves 56-64px which leaves the actual bar overlapping
// page content by ~20px on md+. Use this spacer so screens that follow the
// AppBar reserve enough room.
//
// The bgcolor matches the start of the page gradient
// (linear-gradient(180deg, #fdf6ea 0%, #FBF1E2 30%, #fff 100%)) so the
// translucent AppBar reveals the same cream tone instead of white.
export const NAVBAR_SPACER_SX = {
  height: { xs: 80, md: 100 },
  flexShrink: 0,
  bgcolor: "#fdf6ea",
};
